// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** Northern Mariana Islands */
const MP: PhoneNumberData = [1, 'MP', 10, format0, /^(?:670)/];

export default MP;
